var map = {
	"./after_1.png": 4908,
	"./after_2.png": 4967,
	"./after_3.jpg": 5978,
	"./after_4.jpg": 2441,
	"./after_5.jpg": 7180,
	"./before_1.png": 5749,
	"./before_2.png": 6974,
	"./before_3.png": 6967,
	"./before_4.png": 7352,
	"./before_5.png": 65,
	"./before_6.png": 1082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4560;